module.exports = __webpack_public_path__ + "img/valued tools of the trade.5608406a.png";